import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from 'react-query';
import { QueryKeys } from '../react-query/QueryKeys';
import { getUser } from '../mutations/mutations';
import NotApproved from '../pages/NotApproved';
import Rejected from '../pages/Rejected';
import Loading from '../components/Loading';
import { userStatuses } from '../utils/constants';
import TermsAndConditions from '../pages/TermsAndConditions';

export const IsApprovedRoute = ({ children }: any) => {
  const { user } = useAuth0();
  // const [open, setOpen] = React.useState(false);

  const { data: userData, isLoading } = useQuery(QueryKeys.PROFILE, () =>
    getUser(user?.sub)
  );

  // useEffect(() => {
  //   if (!userData?.user_metadata?.terms) {
  //     setOpen(true);
  //   }
  // }, [userData?.user_metadata?.terms]);

  if (isLoading) {
    return <Loading />;
  }

  // if (!userData?.user_metadata?.terms) {
  //   return (
  //     <TermsAndConditions
  //       open={open}
  //       onClose={() => setOpen(false)}
  //       id={userData?.user_id}
  //     />
  //   );
  // }

  if (userData?.user_metadata?.status === userStatuses.APPROVED) {
    return <>{children}</>;
  } else if (userData?.user_metadata?.status === userStatuses.REJECTED) {
    return <Rejected />;
  } else {
    return <NotApproved />;
  }
};
